import { ILocalValidation } from "../analytics";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { SET_FIELD_VALIDATION_ERROR } from "../store/actions";

export function useLocalValidation(props: ILocalValidation) {
  const dispatch = useDispatch();
  useEffect(() => {
    if (props.state > 0) {
      dispatch({
        type: SET_FIELD_VALIDATION_ERROR,
        payload: props,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.state, props.value]);
}
